export default __webpack_public_path__ + "static/media/SemanticHTML-Thumbnail.181e236a.png";